<template>
    <BasicModalWindow @modalWindowClose="onClose()"
      ref="modal_block_email"
      class="antispam-modal"
      :title="`settings.${list_type}.antispam_modal.title`"
      :loading="list_loading"
      :gtm="{
        module   : `${list_type}_settings`,
        feature  : `${list_type}_modal`,
        block    : `modal_header`,
        action   : 'cancel'
      }"
    >
        <template #body v-if="limit_exceeded === false">
           <slot name="modal_body"></slot>
		    <p>
               {{  Language.say(`settings.${list_type}.antispam_modal.description_1`) }}
            </p>

		   <form>
                <fieldset>
                    <ul class="control-list">
                        <li v-for="item, index in emails_list" :key="item.email">
                            <span v-if="item.rule === 'email'">
                                {{ item.email }}@{{ item.domain }}
                            </span>

                            <span v-else>
                                {{ item.email }}<strong>@{{ item.domain }}</strong>
                            </span>
                            <span>
                                <InputRadio
                                    :input_id="`ats_radio-${index}`"
                                    input_name="radio"
                                    :tag_text="`settings.${list_type}.antispam_modal.options.`"
                                    :options="{'address' : 'email', 'domain': 'domain'}"
                                    v-model:input_value="item.rule"
                                />
                            </span>
                        </li>
                    </ul>
                </fieldset>
			</form>
        </template>

        <template #body v-else>
            <ContainerAlert type="error">
                {{ Language.say(`settings.${list_type}.antispam_modal.limit_exceeded`) }}
            </ContainerAlert>

            <PremiumSubscribe v-if="AccountController.account.premium.allowed"
                :text="`settings.${list_type}.notices.upgrade_message`"
                :gtm="{
                    module : `${list_type}_settings`,
                    feature: `${list_type}_list`,
                    block  : 'modal_body',
                    action : 'premium_subscribe'
                }"
            />
        </template>

        <template #footer>
            <ActionButton
              @click="onClose()"
              text="global.actions.cancel"
              :gtm="{
                module   : `${list_type}_settings`,
                feature  : `${list_type}_modal`,
                block    : `modal_footer`,
                action   : 'cancel'
              }"
            />

            <ActionButton
              @click="onConfirm()"
              :class="[
                confirm_class,
                'push-right',
              ]"
              text="global.actions.confirm"
              :loading="loading"
              :disabled="limit_exceeded"
                :gtm="{
                    module : `${list_type}_settings`,
                    feature: `${list_type}_modal`,
                    block  : `modal_footer`,
                    action : `submit`
                }"
            />
        </template>
    </BasicModalWindow>
</template>

<script setup>
    import { defineProps, defineEmits, reactive } from 'vue';
    import { onBeforeMount, ref }                 from 'vue';
    import BasicModalWindow                       from '@/vue/Layouts/Modals/BasicModalWindow.vue';
    import ActionButton                           from '@/vue/Elements/Buttons/ActionButton.vue'
    import InputRadio                             from '@/vue/Elements/Inputs/InputRadio.vue';
    import Language                               from '@/js/Shared/Language/Language';
    import AntiSpamController                     from '@/js/Settings/AntiSpam/AntiSpamController';
    import AccountController                      from '@/js/Webmail/AccountController';
    import ContainerAlert                         from '@/vue/Elements/Content/ContainerAlert.vue';
    import PremiumSubscribe                       from '@/vue/Views/Webmail/Partials/Premium/PremiumSubscribe.vue';

    const emit  = defineEmits([
        'actionConfirm',
        'actionCancel',
    ]);

    const emails_list    = reactive([])
    const loading        = ref(false);
    const list_loading   = ref(true);
    const limit_exceeded = ref(false);

    const props = defineProps({
        text_confirm : {
            default: 'global.actions.confirm',
        },

        confirm_class : {
            default : 'main-action',
        },

        messages_selection : {
            default : null
        },

        list_type : {
            default : null,
        },
    });

    onBeforeMount(() => {
        setListLoading(true);
        fetchList();
        setListLoading(false);
        setEmailsList();
        setLimitExceeded();
    });

    const onConfirm = async () => {
        setLoading(true);

        if (await addAddresses() == true) {
            emit('actionConfirm');
        }

        setLoading(false);
    }

    const onClose = () => {
        emit('actionClose');
    }

    const addAddresses = async () => {
        let parsed_list = getParsedList();

        let response =(props.list_type === 'whitelist')
            ? await AntiSpamController.addWhitelistSenders(parsed_list)
            : await AntiSpamController.addBlacklistSenders(parsed_list)

        return response;
    }

    const fetchList = async () => {
        (props.list_type === 'whitelist')
            ? await AntiSpamController.fetchWhitelistOnce()
            : await AntiSpamController.fetchBlacklistOnce()
    }

    const setEmailsList = () => {
        let recipients = props.messages_selection.getRecipientEmails();

        for (let i = 0; i < recipients.length; i++) {
            let split = recipients[i].split('@');

            emails_list[i] = {
                email: split[0],
                rule : 'email',
                domain: split[1],
            }
        }
    }

    const setLimitExceeded = () => {
        let size = emails_list.length + AntiSpamController.data[props.list_type].count;

        if (size > AccountController.account.cos[`max_${props.list_type}_entries`]) {
            limit_exceeded.value = true;
            return;
        }

        limit_exceeded.value = false;
    }

    const getParsedList = () => {
        let parsed_list = [];

        for (let i = 0; i < emails_list.length; i++) {
            parsed_list[i] = {
                sender : ((emails_list[i].rule === 'domain') ? emails_list[i].domain : emails_list[i].email + '@' + emails_list[i].domain),
                rule  : emails_list[i].rule,
            }
        }

        return parsed_list;
    }

    const setLoading = (state) => {
        loading.value = state;
    }

    const setListLoading = (state) => {
        list_loading.value = state;
    }
</script>
